export default "__VITE_ASSET__BRBoLXFF__"